import React, { Component } from 'react'
import { Container } from '@sencha/ext-modern'
import Message from '../../components/Message'
import SearchBar from './SearchBar'
import ListItem from './ListItem'

Ext.require([
    'Ext.dataview.listswiper.ListSwiper',
    'Ext.MessageBox'
])
const style = {
    outer: {
        backgroundColor: "#f5f5f5",
        paddingTop: "10px",
        paddingBottom: "10px"
    }
}
class PurchaseTask extends Component {
    state = {
        query: '',
        loading: false,
        errorMessage: null,
        selectedStatus: 0,
        purchaseList: null,
        pageCount: 10,
        page: 1,
        totalCount: 0
    }

    componentDidMount() {
        const { pageCount } = this.state
        this.GetPurchaseList(pageCount)
    }

    GetPurchaseList = (row) => {
        const { query, selectedStatus } = this.state
        const { match: { params: { type } } } = this.props
        Tyan.doPostEvent('GetPurchaseList', {
            data: { type, status: selectedStatus, row, query, },
            onRequest: () => {
                this.setState({ loading: true })
            },
            onEnd: ({ errorMessage, purchaseList, totalCount }) => {
                if (errorMessage) {
                    this.setState({ errorMessage })
                    return
                }
                this.setState({ loading: false, purchaseList, totalCount })
            }
        })
    }

    handleLoadMore = () => {
        let { page, pageCount } = this.state
        page += 1
        this.GetPurchaseList(pageCount * page)
        this.setState({ page })
    }

    handleChange = (field, value) => {
        this.setState({ query: value })
    }

    handleSearch = () => {
        const { pageCount } = this.state
        this.GetPurchaseList(pageCount)
    }

    handleAdd = ({ showDetail }) => {
        // const { match: { params: { type } } } = this.props
        location.hash = `/QYWX/PurchaseApply/0`
    }

    handleSelectStatus = (e) => {
        this.setState({ selectedStatus: e.value })
        const { pageCount } = this.state
        this.GetPurchaseList(pageCount)
    }

    handleChildTap = ({id}) => {
        location.hash = `/QYWX/PurchaseApply/${id}`
    }

    render() {
        const { purchaseList, errorMessage, query, selectedStatus, totalCount } = this.state
        if (errorMessage) {
            return <Message text="数据加载失败" subText={errorMessage} />
        } else if (!purchaseList) {
            return <Message text="数据加载中..." />
        }

        return (
            <Container layout={{ type: "vbox" }} style={style.outer} scrollable >
                <SearchBar selectedStatus={selectedStatus} statusList={[['申请中', 1], ['签核中', 2]]} handleChange={this.handleChange} handleSearch={this.handleSearch} query={query} handleSelectStatus={this.handleSelectStatus} />
                <ListItem listData={purchaseList} totalCount={totalCount} handleLoadMore={this.handleLoadMore} handleChildTap={this.handleChildTap} />
            </Container>
        )
    }
}
export default PurchaseTask